// ============================================================
// ExceptionalFire — Custom Header JS
// Phone injection, mega menu, scroll behavior, mobile menu
// ============================================================

(function() {
  'use strict';

  // ── 1. PHONE INJECTION ──
  var PHONE_DISPLAY = '(949) 619-7824';
  var PHONE_HREF = 'tel:+19496197824';

  document.querySelectorAll('[data-phone-display], [data-phone], .ef-phone-text').forEach(function(el) {
    if (!el.textContent.trim() || el.textContent.trim() === '...') el.textContent = PHONE_DISPLAY;
  });
  document.querySelectorAll('[data-phone-link], a[data-phone], a.ef-phone').forEach(function(el) {
    if (el.tagName === 'A') el.href = PHONE_HREF;
    if (!el.textContent.trim()) el.textContent = PHONE_DISPLAY;
  });

  // ── 1b. MOBILE ROTATING MESSAGES ──
  var mobileMsg = document.getElementById('ef-util-mobile-msg');
  if (mobileMsg) {
    var messages = [
      '<strong>Free Shipping</strong> on All Orders',
      '<strong>Expert Fit Review</strong> on Every Order',
      '<strong>Trade Program</strong> — exclusive pricing'
    ];
    var msgIdx = 0;
    mobileMsg.innerHTML = messages[0];
    setInterval(function() {
      mobileMsg.style.opacity = '0';
      setTimeout(function() {
        msgIdx = (msgIdx + 1) % messages.length;
        mobileMsg.innerHTML = messages[msgIdx];
        mobileMsg.style.opacity = '1';
      }, 300);
    }, 4000);
  }

  // ── 2. STICKY HEADER WITH SHADOW (mobile sticky bar removed for backport) ──
  var header = document.querySelector('#shopify-section-header');
  if (header) {
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          if (window.scrollY > 40) {
            header.classList.add('ef-header--scrolled');
          } else {
            header.classList.remove('ef-header--scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ── 3. MEGA MENU ──
  // Keys match against link text (data-title) AND href — include both space and hyphen variants
  var MEGA_TRIGGERS = {
    'fireplaces': 'ef-mega-fireplaces', /* top-level "Fireplaces" — bez kolizji: 'fireplace doors/screens' nie zawiera ciagu 'fireplaces' */
    'fireplace door': 'ef-mega-doors',
    'fireplace-door': 'ef-mega-doors',
    'fireplace screen': 'ef-mega-screens',
    'fireplace-screen': 'ef-mega-screens',
    'mantel': 'ef-mega-mantels',
    'gas log': 'ef-mega-gaslogs',
    'gas-log': 'ef-mega-gaslogs',
    'fire pit': 'ef-mega-firepits',
    'fire-pit': 'ef-mega-firepits',
    'bbq': null  /* BBQs in More dropdown, no mega menu */
  };

  /* Kategorie z gotowym hubem Navigatora — klik w top-nav NAWIGUJE do collection page
     (polecenie Daniela 2026-08-08). Reszta (fire pits — hub czeka na akceptacje) tylko otwiera mega. */
  var NAV_THROUGH = ['fireplaces', 'fireplace door', 'fireplace-door', 'fireplace screen', 'fireplace-screen', 'mantel', 'gas log', 'gas-log'];

  var activeMenu = null;
  var closeTimer = null;

  function alignNarrowMega(menu, triggerLi) {
    /* Narrow mega menus (Gas Logs, Fire Pits, BBQs) need to be placed
       under their trigger — default `left: 0` would dump them at the
       far-left of the header. Center-align under the <li>. */
    if (!menu.classList.contains('ef-mega--narrow') || !triggerLi) return;
    var header = menu.offsetParent || document.querySelector('#shopify-section-header') || document.body;
    var headerRect = header.getBoundingClientRect();
    var triggerRect = triggerLi.getBoundingClientRect();
    var triggerCenter = triggerRect.left + triggerRect.width / 2 - headerRect.left;
    var menuWidth = menu.offsetWidth || 520;
    var viewport = window.innerWidth;
    var gutter = 16;

    var left = triggerCenter - menuWidth / 2;
    /* Clamp inside viewport so it doesn't fly off-screen on the right edge */
    var maxLeft = (headerRect.width || viewport) - menuWidth - gutter;
    var minLeft = gutter;
    if (left > maxLeft) left = maxLeft;
    if (left < minLeft) left = minLeft;
    menu.style.left = left + 'px';
    menu.style.right = 'auto';
  }

  /* Map of menuId → triggering <li> so we can re-align on open/resize. */
  var menuIdToLi = new Map();

  function openMega(menuId) {
    clearTimeout(closeTimer);
    if (activeMenu && activeMenu.id !== menuId) closeMega(activeMenu);
    var menu = document.getElementById(menuId);
    if (!menu) return;
    alignNarrowMega(menu, menuIdToLi.get(menuId));
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    activeMenu = menu;
    if(menu.id === "ef-mega-bbqs") document.querySelector(".ef-bbq-nav-item button")?.setAttribute("aria-expanded","true");
  }

  function closeMega(menu) {
    if (!menu) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    if (activeMenu === menu) activeMenu = null;
    if(menu.id === "ef-mega-bbqs") document.querySelector(".ef-bbq-nav-item button")?.setAttribute("aria-expanded","false");
  }

  function scheduleClose(menu) {
    closeTimer = setTimeout(function() { closeMega(menu); }, 250);
  }

  // Map each <li> to its mega menu ID
  var liMenuMap = new Map();

  document.querySelectorAll('.header__primary-nav a[data-title], .header__primary-nav summary[data-title], .header__primary-nav-item > a, header summary[data-title]').forEach(function(link) {
    var href = (link.getAttribute('href') || link.getAttribute('data-follow-link') || '').toLowerCase();
    var text = (link.getAttribute('data-title') || link.textContent || '').toLowerCase().trim();

    Object.keys(MEGA_TRIGGERS).forEach(function(key) {
      if (href.includes(key) || text.includes(key)) {
        var menuId = MEGA_TRIGGERS[key];
        var li = link.closest('.header__primary-nav-item');
        if (li) {
          liMenuMap.set(li, menuId);
          if (menuId) menuIdToLi.set(menuId, li);
        }

        link.setAttribute('aria-haspopup', 'true');
        link.addEventListener('click', function(e) {
          if (window.innerWidth >= 1024) {
            if (NAV_THROUGH.indexOf(key) !== -1) {
              var dest = link.getAttribute('href') || link.getAttribute('data-follow-link') || '';
              if (dest && dest.charAt(0) === '/') {
                /* hub gotowy: <a> nawiguje natywnie; summary dostaje jawne przejscie */
                if (link.tagName !== 'A') { e.preventDefault(); window.location.assign(dest); }
                return;
              }
            }
            e.preventDefault(); openMega(menuId);
          }
        });

        var pd = link.closest('details');
        if (pd) pd.addEventListener('toggle', function() {
          if (window.innerWidth >= 1024 && pd.open) pd.removeAttribute('open');
        });
      }
    });
  });

  /* Triggers that don't match by href/text — opt-in via data-mega="ef-mega-*"
     on the <li>. Used by the "More" button which has no href. */
  document.querySelectorAll('.header__primary-nav-item[data-mega]').forEach(function(li) {
    var menuId = li.getAttribute('data-mega');
    if (!menuId || !document.getElementById(menuId)) return;
    liMenuMap.set(li, menuId);
    menuIdToLi.set(menuId, li);
    var trigger = li.querySelector('button, a');
    if (trigger) {
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.addEventListener('click', function(e) {
        if (window.innerWidth >= 1024) {
          e.preventDefault();
          if (activeMenu && activeMenu.id === menuId) closeMega(activeMenu);
          else openMega(menuId);
        }
      });
    }
  });

  // Hover: mouseenter on <li> opens, mouseleave starts close timer
  liMenuMap.forEach(function(menuId, li) {
    li.addEventListener('mouseenter', function() { openMega(menuId); });
    li.addEventListener('mouseleave', function() { scheduleClose(document.getElementById(menuId)); });
  });

  // Keep mega open when hovering the panel
  document.querySelectorAll('.ef-mega').forEach(function(menu) {
    menu.addEventListener('mouseenter', function() { clearTimeout(closeTimer); });
    menu.addEventListener('mouseleave', function() { scheduleClose(menu); });
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && activeMenu) closeMega(activeMenu);
  });

  // Close on click outside
  document.addEventListener('click', function(e) {
    if (activeMenu && !activeMenu.contains(e.target) && !e.target.closest('header')) {
      closeMega(activeMenu);
    }
  });

  // ── 4. MOBILE MENU FOOTER ──
  var mobileMenu = document.querySelector('.header__sidebar, .sidebar-menu, [id*="sidebar"]');
  if (mobileMenu) {
    var phoneFooter = document.createElement('div');
    phoneFooter.className = 'ef-mobile-menu-footer';
    phoneFooter.innerHTML =
      '<a href="' + PHONE_HREF + '" class="ef-mobile-phone">' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round">' +
          '<path d="M14 11.5a11 11 0 00-2.6-1.7c-.8-.3-1.1 0-1.6.5l-.7.8a9.6 9.6 0 01-4.2-4.2l.8-.7c.5-.5.8-.8.5-1.6A11 11 0 004.5 2 1 1 0 003 2l-1 1C.8 4.4 1.5 7 4 9.5 6.5 12 9.1 12.7 10.5 11.5l1-1a1 1 0 000-1z"/>' +
        '</svg>' +
        PHONE_DISPLAY +
      '</a>' +
      '<a href="/pages/free-consultation" class="ef-mobile-consult">Book a Free Consultation &rarr;</a>';
    mobileMenu.appendChild(phoneFooter);
  }

  // ── 5. SEARCH BAR ──
  // Capture-phase: catch click before Prestige native search popover opens via aria-controls.
  function openEFSearch(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
    if (typeof window.efSearchOpen === 'function') window.efSearchOpen();
  }

  // Desktop search bar
  var searchBar = document.querySelector('.ef-search-bar__btn');
  if (searchBar) {
    searchBar.addEventListener('click', openEFSearch, true);
  }

  // Mobile + nav search icon (Prestige header__search-link <a> + any aria-controls="header-search-*")
  document.addEventListener('click', function(e) {
    var link = e.target.closest && e.target.closest('.header__search-link a, a[aria-controls^="header-search-"], button[aria-controls^="header-search-"]');
    if (link) openEFSearch(e);
  }, true);

  // Cmd+K / Ctrl+K keyboard shortcut
  document.addEventListener('keydown', function(e) {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      if (typeof window.efSearchOpen === 'function') window.efSearchOpen();
    }
  });

})();
